<div class="floating-panel" [class.closing]="isClosing()">
  <mat-card class="floating-card">
    <div class="close-button-container">
      @if (autoClosing()) {
        <svg class="countdown-ring" viewBox="0 0 40 40">
          <circle cx="20" cy="20" r="17" />
        </svg>
      }
      <button mat-icon-button class="close-button" (click)="close()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</div>
